var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Prop, Component, Vue, Watch } from "vue-property-decorator";
import SummaryPartnerControl from '@/template/components/summaryReport/controls/SummaryPartnerControl.vue';
import NumericInputRow from '@/common/components/NumericInputRow.vue';
import RadioButtonRow from '@/common/components/RadioButtonRow.vue';
import { ContinuousReportPartner } from '@/common/types/ContinuousReportPartner';
import { CooperationType } from "@/common/types/CooperationType";
import CheckBoxDialogRow from "@/common/components/CheckBoxDialogRow.vue";
var PartnerControl = /** @class */ (function (_super) {
    __extends(PartnerControl, _super);
    function PartnerControl() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.radioButtonValueChanged = "";
        return _this;
    }
    Object.defineProperty(PartnerControl.prototype, "showRedirectedCustomerFields", {
        get: function () {
            return this.partner.cooperationTypes.some(function (x) { return x.id == CooperationType.CustomerGuidance; });
        },
        enumerable: false,
        configurable: true
    });
    PartnerControl.prototype.onRedirectedSelectionChange = function () {
        if (!this.showRedirectedCustomerFields) {
            this.partner.redirectedCustomersWereCounted = null;
            this.partner.redirectedCustomersToPartnerCount = null;
            this.partner.redirectedCustomersFromPartnerCount = null;
        }
    };
    Object.defineProperty(PartnerControl.prototype, "hasTargets", {
        get: function () {
            return this.targets && this.targets.length > 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PartnerControl.prototype, "redirectedCustomersModified", {
        get: function () {
            return this.partner.redirectedCustomersToPartnerCount != null || this.partner.redirectedCustomersFromPartnerCount != null;
        },
        enumerable: false,
        configurable: true
    });
    PartnerControl.prototype.onRadioChange = function () {
        if (this.partner.redirectedCustomersWereCounted === false && this.redirectedCustomersModified) {
            if (confirm(this.$t("ContinuousReport.Confirm.RedirectedCustomerChange").toString())) {
                this.partner.redirectedCustomersToPartnerCount = null;
                this.partner.redirectedCustomersFromPartnerCount = null;
            }
            else {
                this.partner.redirectedCustomersWereCounted = true;
                this.radioButtonValueChanged = Date();
            }
        }
    };
    var _a;
    __decorate([
        Prop(String),
        __metadata("design:type", String)
    ], PartnerControl.prototype, "title", void 0);
    __decorate([
        Prop(Object),
        __metadata("design:type", typeof (_a = typeof ContinuousReportPartner !== "undefined" && ContinuousReportPartner) === "function" ? _a : Object)
    ], PartnerControl.prototype, "partner", void 0);
    __decorate([
        Prop(Number),
        __metadata("design:type", Number)
    ], PartnerControl.prototype, "index", void 0);
    __decorate([
        Prop(Array),
        __metadata("design:type", Array)
    ], PartnerControl.prototype, "targets", void 0);
    __decorate([
        Prop(Array),
        __metadata("design:type", Array)
    ], PartnerControl.prototype, "targetGroups", void 0);
    __decorate([
        Watch('showRedirectedCustomerFields'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], PartnerControl.prototype, "onRedirectedSelectionChange", null);
    __decorate([
        Watch('partner.redirectedCustomersWereCounted'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], PartnerControl.prototype, "onRadioChange", null);
    PartnerControl = __decorate([
        Component({
            name: "PartnerControl",
            components: {
                SummaryPartnerControl: SummaryPartnerControl,
                NumericInputRow: NumericInputRow,
                RadioButtonRow: RadioButtonRow,
                CheckBoxDialogRow: CheckBoxDialogRow
            }
        })
    ], PartnerControl);
    return PartnerControl;
}(Vue));
export default PartnerControl;
